import React from "react";
import "./examCTAList.css";
import calendarImg from "../../../../assets/medical/appointment/calendar.png";
import phoneImg from "../../../../assets/medical/appointment/phone-call.png";
import landlinePhoneImg from "../../../../assets/medical/appointment/telephone.png";
import emailImg from "../../../../assets/medical/appointment/email.png";
import locationImg from "../../../../assets/medical/appointment/maps-and-flags.png";

const ExamCTAList = ({ isOtthoniMintavetel }) => {
  return (
    <>
      <ul
        className="exam-company-contact-list"
        aria-label="Kapcsolatfelvételi lehetőségek"
      >
        {!isOtthoniMintavetel && (
          <>
            <li className="exam-company-contact-item">
              <span
                className="exam-company-contact-item-icon"
                aria-hidden="true"
              >
                <span className="exam-company-contact-item-icon-inner">
                  <img
                    src={calendarImg}
                    alt="Naptár ikon"
                    width="24"
                    height="24"
                    loading="lazy"
                  />
                </span>
              </span>
              <a
                href="https://balintanalitika.booked4.us"
                target="_blank"
                rel="noreferrer noopener"
                className="exam-company-contact-item-text"
                aria-label="Online időpontfoglalás a Bálint Analitikához"
              >
                Online időpontfoglalás
              </a>
            </li>
            <li className="exam-company-contact-item">
              <span
                className="exam-company-contact-item-icon"
                aria-hidden="true"
              >
                <span className="exam-company-contact-item-icon-inner">
                  <img
                    src={emailImg}
                    alt="Email ikon"
                    width="24"
                    height="24"
                    loading="lazy"
                  />
                </span>
              </span>
              <a
                href="mailto:orvosdiagnosztika@balintanalitika.hu"
                className="exam-company-contact-item-text"
                aria-label="Email küldése az orvosdiagnosztika@balintanalitika.hu címre"
              >
                orvosdiagnosztika@balintanalitika.hu
              </a>
            </li>
          </>
        )}
        <li className="exam-company-contact-item">
          <span className="exam-company-contact-item-icon" aria-hidden="true">
            <span className="exam-company-contact-item-icon-inner">
              <img
                src={landlinePhoneImg}
                alt="Vezetékes telefon ikon"
                width="24"
                height="24"
                loading="lazy"
              />
            </span>
          </span>

          <a
            href="tel:+3612053044"
            className="exam-company-contact-item-text"
            aria-label="Hívás a vezetékes telefonszámon: 06 1 205 3044"
          >
            <span className="sr-only">Vezetékes: </span>06 1 205 3044
          </a>
        </li>
        <li className="exam-company-contact-item">
          <span className="exam-company-contact-item-icon" aria-hidden="true">
            <span className="exam-company-contact-item-icon-inner">
              <img
                src={phoneImg}
                alt="Mobiltelefon ikon"
                width="24"
                height="24"
                loading="lazy"
              />
            </span>
          </span>

          <a
            href="tel:+36202542591"
            className="exam-company-contact-item-text"
            aria-label="Hívás a mobil telefonszámon: 06 20 254 2591"
          >
            <span className="sr-only">Mobil: </span>06 20 254 2591
          </a>
        </li>
        <li className="exam-company-contact-item">
          <span className="exam-company-contact-item-icon" aria-hidden="true">
            <span className="exam-company-contact-item-icon-inner">
              <img
                src={locationImg}
                alt="Helyszín ikon"
                width="24"
                height="24"
                loading="lazy"
              />
            </span>
          </span>
          <a
            href="https://maps.app.goo.gl/1fHpr1EnwQT4j3Wy6"
            target="_blank"
            rel="noreferrer noopener"
            className="exam-company-contact-item-text"
            aria-label="Laboratóriumunk helyszíne: Budapest XI. kerület, Kondorfa utca 6."
          >
            Budapest XI. kerület, Kondorfa utca 6.
          </a>
        </li>
      </ul>

      {/* Add service area information for local SEO */}
      {isOtthoniMintavetel && (
        <div className="service-areas">
          <p className="service-areas-text">
            <strong>Szolgáltatási területeink:</strong> Budapest IX. kerület,
            XI. kerület, XXII. kerület
          </p>
        </div>
      )}
    </>
  );
};

export default ExamCTAList;
